import React from 'react';

const fmtK = (n) => {
  const v = Math.abs(n || 0);
  if (v >= 1000) return `$${Math.round((n || 0) / 1000)}k`;
  return `$${Math.round(n || 0)}`;
};

/**
 * Monthly margin goal progress. Recognised margin is the solid bar; the
 * in-flight pipeline extends it as a lighter segment so a rep can see
 * "booked" vs "still to deliver" against the same goal.
 */
export const MarginGoalBar = ({
  goal = 0,
  recognised = 0,
  pipeline = 0,
  includePipeline = false,
  compact = false,
  testId = 'margin-goal-bar',
}) => {
  if (!goal || goal <= 0) {
    return (
      <span className="text-[10.5px] text-slate-400" data-testid={`${testId}-unset`}>
        no goal set
      </span>
    );
  }

  const recPct = Math.min(100, (recognised / goal) * 100);
  const pipePct = includePipeline ? Math.min(100 - recPct, (pipeline / goal) * 100) : 0;
  const hitGoal = recognised >= goal;
  const combinedHits = !hitGoal && includePipeline && recognised + pipeline >= goal;

  return (
    <div className={compact ? 'w-full' : 'w-full min-w-[120px]'} data-testid={testId}>
      <div className="h-1.5 w-full rounded-full bg-slate-200 overflow-hidden flex">
        <div
          className={`h-full ${hitGoal ? 'bg-emerald-500' : 'bg-indigo-500'} transition-all`}
          style={{ width: `${recPct}%` }}
        />
        {pipePct > 0 && (
          <div
            className="h-full bg-amber-300 transition-all"
            style={{ width: `${pipePct}%` }}
            title={`${fmtK(pipeline)} still in the pipeline`}
          />
        )}
      </div>
      <div className="flex items-center justify-between gap-2 mt-0.5">
        <span
          className={`text-[10.5px] font-medium ${hitGoal ? 'text-emerald-700' : combinedHits ? 'text-amber-700' : 'text-slate-600'}`}
          data-testid={`${testId}-label`}
        >
          {fmtK(recognised)} of {fmtK(goal)}
        </span>
        <span className="text-[10.5px] text-slate-500">
          {Math.round((recognised / goal) * 100)}%
          {includePipeline && pipeline > 0
            ? ` (+${Math.round((pipeline / goal) * 100)}%)`
            : ''}
        </span>
      </div>
    </div>
  );
};

export default MarginGoalBar;
